import React from 'react';

import {getFormattedDate} from 'shared/lib/datetime';
import {nv} from 'shared/lib/format/string';
import {IPayment, PaymentStatusBadge} from 'entities/payment';

import YesNo from '../../../../shared/ui/YesNo/YesNo';

interface IPaymentRowProps {
    item: IPayment,
    tzString?: string | null,
}

const PaymentRow: React.FC<IPaymentRowProps> = ({item, tzString}) => {

    return (
        <tr>
            <td>{item.id}</td>
            <td>{item.number}</td>
            <td>{item.user?.email}</td>
            <td>{getFormattedDate(item.created_at, {tzString})}</td>
            <td>{item.sum} руб</td>
            <td>{nv(item.promo_code_value)}</td>
            <td>{item.tariff.name}{item.tariff.is_archive && ' (арх.)'}</td>
            <td>{item.variant?.period ?? '30'}</td>
            <td><PaymentStatusBadge status={item.status}/></td>
            <td><YesNo condition={item.auto}/></td>
            <td>{getFormattedDate(item.payed_at, {tzString})}</td>
        </tr>
    );
};

export default PaymentRow;